import Vue from "vue";
import VueRouter from "vue-router";
import ValidationList from "../views/validations/ValidationList.vue";
import ValidationUpdate from "../views/validations/ValidationUpdate.vue";
import HomeView from "../views/validations/HomeView.vue";
import ValidationListCommunication from "../views/validations/ValidationListCommunication.vue";
import ValidationUpdateCommunication from "../views/validations/ValidationUpdateCommunication.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomeView",
    component: HomeView,
  },
  {
    path: "/validations",
    name: "ValidationList",
    component: ValidationList,
  },
  {
    path: "/orders/:_id/validations",
    name: "ValidationUpdate",
    component: ValidationUpdate,
  },
  {
    path: "/service-communication/orders",
    name: "ServiceCommunicationHome",
    component: ValidationListCommunication,
  },
  {
    path: "/service-communication/validations",
    name: "ServiceCommunicationHome",
    component: ValidationListCommunication,
  },
  {
    path: "/service-communication/orders/:_id/validations",
    name: "ValidationUpdate",
    component: ValidationUpdateCommunication,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
